<template>
  <div class="swiper-wrap">
    <div class="swiper-container" v-if="articleSwiper.length">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="item in articleSwiper" :key="item.ID">
          <img
            class="swiper-img"
            :src="item.PIC_URL"
            @click="handleBannerClick(item)"
            alt="swiper-img"
          />
        </div>
      </div>
    </div>
    <div class="swiper-container" v-else>
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img :src="emptyDefaultImg" alt="banner-img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, nextTick, watch } from 'vue';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import useArticleJumpLink from '@hooks/useArticleJumpLink';
const props = defineProps({
  swiperList: {
    default: [],
  },
  emptyDefaultImg: {
    default: '',
  },
  source: {
    default: '',
  },
});
const articleSwiper = ref(props.swiperList);

watch(
  () => props.swiperList,
  (newVal) => {
    articleSwiper.value = newVal;
  },
  {
    immediate: true,
    deep: true,
  }
);

watch(
  articleSwiper,
  () => {
    if (articleSwiper.value.length) {
      nextTick(() => {
        initSwiper();
      });
    }
  },
  {
    immediate: true,
    deep: true,
  }
);

const { articleJumpLink } = useArticleJumpLink();

const initSwiper = () => {
  new Swiper('.swiper-container', {
    loop: false,
    autoplay: {
      delay: 4000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    direction: 'horizontal',
    pagination: {
      el: '.swiper-pagination',
    },
    effect: 'slide', // flip:3d翻转  slide:位移切换  fade:淡入  cube:方块  coverflow:3d流
    observer: true,
    observeParents: true,
  });
};

const handleBannerClick = (item) => {
  console.log('item', item);
  clickButtonPoint({
    btnName: 'banner',
    moduleName: props.moduleName,
  });
  articleJumpLink({
    id: item.ARTICLE_GROUP_ID,
    articleType: item.CAROUSEL_TYPE,
    target: item.REDIRECT_TYPE,
    redirectLink: item.REDIRECT_LINK,
    source: props.source || '',
  });
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/dimen.scss';
@import '@assets/scss/mixin.scss';
.swiper-wrap {
  position: relative;
  margin: 0 auto;
  width: 100%;
}
.swiper-container {
  position: relative;
  width: 100%;
  height: 240px;

  a,
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.swiper-img {
  cursor: pointer;
  @include addTouchEffect();
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
  .swiper-container {
    height: calc(240px / $pcRate);
  }
}
</style>
